export default __webpack_public_path__ + "static/media/contact-01.31b71a39.png";